
<div :class="jel_getClassObject(content)">
  <Titre
    :content="{
      titre: content.titreVerification,
      type: 'titre',
    }"
  />
  <template v-if="isContenuAffiche">
    <MessageMel
      v-if="isErreurSessionExpire && contentMessage.sessionExpire"
      class="mb-2 mt-1"
      :content="contentMessage.sessionExpire"
    />

    <MessageMel
      v-if="isErreurRecuperation && contentMessage.recuperation"
      class="mb-1"
      :content="contentMessage.recuperation"
    />
    <template v-else>
      <!-- Section Vérification en 2 étapes -->
      <template>
        <!-- Si il y a un MFA actif -->
        <template v-if="mfaBase">
          <div v-html="content.libMfaActive" />
          <MessageMel
            v-if="isErreurReinitialisationRetirer && contentMessage.reinitialisationRetirer"
            class="mt-1 mb-0"
            :content="contentMessage.reinitialisationRetirer"
          />
          <div class="liste pt-2">
            <div class="defaut">
              <span>
                {{
                  mfaBase.type === 'totp'
                    ? content.libOptionAuthenticator
                    : `${content.libOptionTelephone} ***${
                        $i18n.locale == 'en' ? '-' : ' '
                      }***-${mfaBase?.phone_number.slice(-4)}`
                }}
              </span>
            </div>
          </div>
          <div class="mt-1">
            <button class="bouton lienPrimaire p-0" @click="afficherModaleModifierMfa()">
              {{ content.libLienModifierVerification }}
            </button>
          </div>
        </template>
        <!-- Si il n'y a pas de MFA actif -->
        <template v-else>
          <MessageMel
            v-if="isErreurClearChoice && contentMessage.clearChoice"
            class="mt-1 mb-0"
            :content="contentMessage.clearChoice"
          />

          <div v-if="isBiometrieActive" v-html="content.libActiverMfaBiometrieActive" />
          <div v-else v-html="content.libMfaDesactive" />
          <MessageMel
            v-if="isErreurReconnexion && contentMessage.reconnexion"
            class="my-1"
            :content="contentMessage.reconnexion"
          />
          <template v-else>
            <Hyperlien v-if="content.libTexteAide" :content="contentLienAide" />
            <button class="bouton lienPrimaire p-0 mt-1" @click="verificationMFA()">
              {{ content.libActiverVerification }}
            </button>
          </template>
          <MessageMel
            v-if="isErreurActivation && contentMessage.activation"
            class="mt-1 mb-0"
            :content="contentMessage.activation"
          />
        </template>
      </template>
      <!-- Section Appareils enregistrés -->
      <template v-if="content.activerBiometrie === 'true'">
        <Titre
          :content="{
            titre: content.titreAppareil,
            type: 'titre',
          }"
        />
        <div v-if="isAppareilRetireSucces" class="mb-1">
          <span class="d-inline-flex cercleSucces cercleSucces-contenu m-0">
            {{ '&#10003;' }}
          </span>
          <span class="pl-1" v-html="content.libAppareilRetireSucces" />
        </div>
        <div class="mb-0" v-html="content.libAppareil" />

        <MessageMel
          v-if="isErreurRetirer && contentMessage.retirer"
          class="mb-0 mt-1"
          :content="contentMessage.retirer"
        />
        <div class="w-100 liste pt-2">
          <div v-if="!isBiometrieActive" class="defaut">
            <span>{{ content.libAucunAppareil }}</span>
          </div>
          <template v-else>
            <div v-for="appareil in listeBiometrie" :key="appareil.mfa_id" class="appareil">
              <span>{{ appareil.device_name }}</span>
              <button
                class="bouton-appareil lienPrimaire float-right p-0"
                @click="afficherModaleRetirerAppareil(appareil)"
              >
                {{ content.libLienRetirerAppareil }}
              </button>
            </div>
          </template>
        </div>
      </template>
      <b-modal
        v-model="isAfficherModale"
        :hide-footer="true"
        dialog-class="d-flex align-items-center h-100"
        header-class="d-none"
        body-class="compteClair"
      >
        <Titre
          :content="{
            titre: modaleTitre,
            type: 'titre',
          }"
        />
        <div v-if="modaleTexte" v-html="modaleTexte" />
        <div class="modale-boutons">
          <b-button class="btn btn-primaire px-4 mt-2 mb-1" @click="confirmerModale()">
            <span>{{ content.libModaleBoutonConfirmer }}</span>
          </b-button>
          <button class="bouton-secondaire lienSecondaire" @click="isAfficherModale = false">
            {{ content.libModaleBoutonAnnuler }}
          </button>
        </div>
      </b-modal>
    </template>
  </template>
</div>
